import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LogOut } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="navbar-logo">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-cyan-500 flex items-center justify-center animate-pulse-glow">
            <Sparkles size={18} className="text-white" />
          </div>
          <span className="text-lg font-bold tracking-tight" style={{ fontFamily: 'Outfit' }}>
            AutoSaaS<span className="text-indigo-400">.ai</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm text-gray-300">
          <a href="/#comment" className="hover:text-white transition-colors" data-testid="nav-link-how">Comment ça marche</a>
          <a href="/#tarifs" className="hover:text-white transition-colors" data-testid="nav-link-pricing">Tarifs</a>
          <a href="/#temoignages" className="hover:text-white transition-colors" data-testid="nav-link-testimonials">Témoignages</a>
        </div>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <button
                onClick={() => navigate("/tableau-de-bord")}
                className="pill-ghost text-sm"
                data-testid="navbar-dashboard-button"
              >
                Tableau de bord
              </button>
              <button
                onClick={() => { logout(); navigate("/"); }}
                className="p-2 rounded-full hover:bg-white/5 text-gray-400 hover:text-white transition-colors"
                data-testid="navbar-logout-button"
                aria-label="Déconnexion"
              >
                <LogOut size={18} />
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/connexion")}
                className="pill-ghost text-sm"
                data-testid="navbar-login-button"
              >
                Connexion
              </button>
              <button
                onClick={() => navigate("/inscription")}
                className="pill-primary text-sm"
                data-testid="navbar-signup-button"
              >
                Commencer
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
